import { observer } from 'mobx-react-lite';

import { useOpponentsVideo } from '@gem/call/CallView/hooks/useOpponentsVideo/useOpponentsVideo';

import styles from './OpponentList.styles.m.css';
import { OpponentsView } from './components/OpponentsView/OpponentsView';

export const OpponentList = observer(() => {
  const { opponentsKeys } = useOpponentsVideo();

  return (
    <div className={styles.container}>
      <OpponentsView opponentsKeys={opponentsKeys} />
    </div>
  );
});
